export const addressConfig: [string, string, string, string] = [
  'Camperoni, Inc.',
  '6417 Penn Ave S Ste 7 -1422',
  'Minneapolis MN 55423-1196',
  'United States',
]
export const emailAddress: string = 'email@camperoni.com'

export const storeKey: string = '49'

export const campsEndpoint = '/api/camps'
